import React from "react";
import { Upload } from "antd";
import StorageUtils from "../../../utils/storage-session-utils";
import notifyUtitls from "../../../utils/notify-utils";

const UploadFile = ({ children, limitSize, ...props }) => {
  const { fileList = [] } = props;
  const uploadTempEndpoint =
    process.env.REACT_APP_API_ENDPOINT + "/upload/temp";
  const headers = {
    Authorization: "Bearer " + StorageUtils.getToken(),
  };
  const beforeUpload = (file) => {
    const duplicate = fileList.find(({ name }) => name === file.name);
    if (duplicate) {
      notifyUtitls.warning("แจ้งเตือน", "ไฟล์อัพโหลดมีชื่อซ้ำ!");
      return Upload.LIST_IGNORE;
    }

    const filename = file.name.length > 75;
    if (filename) {
      notifyUtitls.warning("แจ้งเตือน", "ชื่อไฟล์ต้องไม่เกิน 75 ตัวอักษร");
      return Upload.LIST_IGNORE;
    }

    //TODO: validate ext.
    // if (!file.type.includes("image/")) {
    //   notifyUtitls.error({
    //     title: "แจ้งเตือน",
    //     message: "ประเภทไฟล์รูปภาพไม่ถูกต้อง",
    //   });
    //   return Upload.LIST_IGNORE;
    // }

    if (file.size === 0) {
      notifyUtitls.error({
        title: "แจ้งเตือน",
        message: "ไฟล์ต้องมีขนาดไม่เกิน " + limitSize + " bytes.",
      });
      return Upload.LIST_IGNORE;
    }

    if (limitSize && file.size > limitSize) {
      notifyUtitls.error({
        title: "แจ้งเตือน",
        message: "ไฟล์ต้องมีขนาดไม่เกิน " + limitSize + " bytes.",
      });
      return Upload.LIST_IGNORE;
    }
  };

  return (
    <Upload
      {...props}
      action={uploadTempEndpoint}
      method="POST"
      headers={headers}
      beforeUpload={beforeUpload}
    >
      {children}
    </Upload>
  );
};

export default UploadFile;
